

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
} from './types';
import {
    ProviderModal
} from './providermodal';

/**
 * Redux action creator to set the list
 * of providers
 * @param providerstate providers information
 * @returns action instance
 */
export const setAction = (providerstate: ProviderModal[]):
    Action<typeof SET, ProviderModal[]> => ({
        type: SET,
        payload: providerstate,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * Alias for setAction to match epic naming
 */
export const setProvidersAction = setAction;

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction>;

